import React from 'react';
import styles from './index.module.less';
import image from './comment.png';

const Comments = () => {
  return (
    <div className={styles.comments}>
      <div className={styles.title}>学员评价</div>
      <div className={styles.desc}>成功帮助上万人学会编程</div>
      <div className={styles.content}>
        <img src={image} alt=""/>
      </div>
    </div>
  );
};

export default Comments;
